import PropTypes from 'prop-types'
import { Badge } from '@components/ui/badge'
import { X } from 'lucide-react'
import { cn } from 'lib/utils'

export const AdasChip = ({ label, onDelete, color, variant, className, size, icon, sx, ...props }) => (
  <Badge
    variant={variant === 'outlined' ? 'outline' : 'secondary'}
    className={cn(
      'rounded-badge gap-1 cursor-default',
      size === 'small' && 'text-[10px] px-1.5 py-0',
      color === 'primary' && 'bg-primary text-primary-foreground',
      color === 'error' && 'bg-error text-primary-foreground',
      color === 'success' && 'bg-success text-primary-foreground',
      color === 'warning' && 'bg-warning text-primary-foreground',
      className
    )}
    {...props}
  >
    {icon && <span className='flex items-center'>{icon}</span>}
    {label}
    {onDelete && (
      <button onClick={onDelete} aria-label='Remove' className='ml-1 hover:opacity-70'>
        <X className='w-3 h-3' />
      </button>
    )}
  </Badge>
)

AdasChip.propTypes = {
  label: PropTypes.node,
  onDelete: PropTypes.func,
  color: PropTypes.string,
  variant: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.node
}
